import { Action } from '@ngrx/store';

export enum SecurityActionTypes {
  INIT_PROPERTY_WALL = '[Cyclops Security] Init Property Wall',
  RESET_STATE = '[Cyclops Security] Reset State',
}
export class ResetState implements Action {
  readonly type = SecurityActionTypes.RESET_STATE;
  constructor(public payload: any) {}
}
export class InitPropertyWall implements Action {
  readonly type = SecurityActionTypes.INIT_PROPERTY_WALL;
  constructor(public payload: any) {}
}
export type CyclopsSecurityActionUnion = ResetState | InitPropertyWall;
